export default __webpack_public_path__ + "static/media/home-3.5d051449.jpg";